<template>
  <nav>
    <div class="nav-header">
      <router-link to="/" tag="img" :src="require(`../assets/img/logo.png`)" />

      <img
        class="mobile-menu"
        :src="require(`../assets/img/${toggleIcon[toggleFlag]}.svg`)"
        @click="toggleNav"
      />
    </div>

    <div class="nav-body" :class="'nav-body--' + toggleIcon[toggleFlag]">
      <ul>
        <li
          v-for="(item, idx) in list"
          tag="li"
          :key="idx"
          @click="route(item)"  
        >
          <div class="list__item">
            <img
              :src="require(`../assets/img/${item.image}.svg`)"
              class="list__icon"
            />
            <span class="list__item__name">{{ item.name }}</span>
          </div>
        </li>
      </ul>

      <div class="copyright">
        <span class="text">
          <span>COPYRIGHT ⓒ 2018</span>
          <span>PAYPROTOCOL. ALL RIGHT</span>
          <span>RESERVED</span>
        </span>
      </div>
    </div>
  </nav>
</template>

<script>
import EventBus from "../js/event_bus";
import { RecordOptions } from "../js/fields";
import { setTweenMaxAppear, setTweenMaxDisappear } from "../js/tweenmax";
import { observeSizeOfApp } from "../js/style";

export default {
  mounted() {
    // this.tween = setTweenMaxAppear();
    EventBus.$on("mobile", (flag) => {
      // this.responsiveTween(flag);
      this.isMobile = flag;
    });
    observeSizeOfApp();
  },

  data() {
    return {
      isMobile: false,
      // tween: null,
      list: [
        {
          link: `/`,
          image: "dashboard",
          name: "Dashboard",
        },
        {
          link: `/blocks`,
          image: "block",
          name: "Blocks",
        },
        {
          link: `/txs`,
          image: "transfer",
          name: "Transactions",
        },
        {
          link: `/circulating`,
          image: "circulating",
          name: "Circulating",
        },
        {
          link: `/unwrap`,
          image: "unwrap",
          name: "wPCI to PCI",
        },
        {
          link: `/richaccounts`,
          image: "richaccount",
          name: "Rich Accounts",
        },
        {
          link: `/txs?pagesize=25&direction=first&function_name=token%2Fburn`,
          image: "burn",
          name: "Burn",
        },
      ],

      toggleIcon: {
        true: "menu",
        false: "menu-cancel",
      },

      toggleFlag: true,
    };
  },

  methods: {
    route(item) { 
      // unwrap 폐쇄 alert 메시지
      // if (item.name === 'wPCI to PCI') { 
      //   alert('Due to the Ethereum (ETH) network hard fork, the wPCI to PCI function will be temporarily suspended from May 7, 2025 (Wed) 05:00 UTC until network stability is confirmed.');
      // }
      this.$router.push(item.link).catch((_) => {});

      if (this.isMobile) {
        this.toggleNav();
      }
    },

    toggleNav() {
      this.toggleFlag = !this.toggleFlag;

      // this.responsiveTween(this.toggleFlag);
    },

    responsiveTween(flag) {
      this.tween.kill();
      switch (flag) {
        case true:
          this.tween = setTweenMaxDisappear();
          break;
        case false:
          this.tween = setTweenMaxAppear();
          break;
      }
      this.tween.restart();
    },
  },
};
</script>

<style lang="scss">
@import "../scss/common";

nav {
  display: flex;
  flex-direction: column;
  background-color: #252b5d;

  .nav-header {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: solid 1px #1a1f4a;

    img {
      cursor: pointer;
    }

    .mobile-menu {
      display: none;
    }
  }

  .nav-body {
    animation: listGrow 0.2s linear;
    flex: auto;
    display: flex;
    flex-direction: column;

    // max-height: 100%;
    // @include slideTransition(top, linear, 1);
  }

  ul {
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    list-style: none;

    li {
      width: 100%;
      height: 51px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #fff;
      font-size: 16px;
      font-weight: 300;
      transition: background-color 0.5s;

      // &:hover {
      //   color: #0393f4;
      //   transition: color 1s;
      // }
    }

    .list__item {
      display: flex;
    }

    .list__item__name {
        word-break: normal;
    }

    .list__icon {
      margin: 0 10px 0 30px;
    }

    .routed {
      background-color: #0393f4;
      transition: background-color 0.5s;
    }
  }

  .copyright {
    margin: auto 0 50px;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      margin-bottom: 20px;
    }

    .text {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #8a8dad;
      font-size: 11px;
      font-weight: 200;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue